import loading from './index.vue'

const components={
  install(Vue){
    Vue.component('app-list-loading', loading)
  }
}

if(typeof window !=='undefined' && window.Vue){
  install(window.Vue);
}
 
export default components;
